import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useCompany } from "../context/CompanyContext";
import {
  canAccessBusinessPath,
  getDefaultPathForRole,
} from "../auth/roleAccess";

export default function RequireRole({ children }) {
  const { plan, companyRole, businessRole } = useCompany();
  const location = useLocation();

  if (!companyRole) {
    return <div style={{ padding: 16 }}>Loading…</div>;
  }

  if (plan !== "business") {
    return companyRole === "admin" || companyRole === "member" ? (
      children
    ) : (
      <Navigate to="/dashboard" replace />
    );
  }

  if (!businessRole) {
    return <Navigate to="/dashboard" replace />;
  }

  const allowed = canAccessBusinessPath(businessRole, location.pathname);

  if (!allowed) {
    return (
      <Navigate
        to={getDefaultPathForRole(businessRole)}
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
}
